import { turbine } from "neql"

const toReadableFormat = (s: String) => s.toLowerCase().split("_").join(" ")

export interface QualifierCardMetricModel {
    value: string
    description: string
}

export const tutorialCorrectAnswers = [
    turbine.TrainingCorrectAnswer.Skip,
    turbine.TrainingCorrectAnswer.ShowAlways,
    turbine.TrainingCorrectAnswer.ShowIfIncorrect
]

export const metricOperators = [
    turbine.MetricOperator.EqualsTo,
    turbine.MetricOperator.GreaterThan,
    turbine.MetricOperator.GreaterThanOrEqualsTo
]

const tutorialCorrectAnswerDisplayTextMapping = {
    [turbine.TrainingCorrectAnswer.Skip]: "never",
    [turbine.TrainingCorrectAnswer.ShowIfIncorrect]:
        "only if worker answer is incorrect",
    [turbine.TrainingCorrectAnswer.ShowAlways]: "always"
}

export function getQualifierMetricOperatorDisplayText(
    op: turbine.MetricOperator
): string {
    return `is ${toReadableFormat(op)}`
}

export const getTutorialCorrectAnswerOptionDisplayText = (
    correctAnswerOption: turbine.TrainingCorrectAnswer
): string => tutorialCorrectAnswerDisplayTextMapping[correctAnswerOption]

export const TRAINING_CREATING_ID = "creating"

export const defaultTest: turbine.TrainingTest = {
    id: TRAINING_CREATING_ID,
    taskInfo: {
        title: "Test",
        description: "A short task summary for the Human Worker goes here..."
    },
    coolOffMinutes: 60,
    numQuestions: 10,
    cutoffValue: 0.9,
    cutoffOperator: turbine.MetricOperator.GreaterThan,
    trainingState: turbine.TrainingState.Creating,
    state: turbine.TrainingApplicationState.Active,
    appUuid: "",
    trainingId: TRAINING_CREATING_ID
}

export const defaultTutorial: turbine.TrainingTutorial = {
    id: TRAINING_CREATING_ID,
    taskInfo: {
        title: "Tutorial",
        description: "A short task summary for the Human Worker goes here..."
    },
    correctAnswer: turbine.TrainingCorrectAnswer.Skip,
    appUuid: "",
    trainingState: turbine.TrainingState.Creating,
    state: turbine.TrainingApplicationState.Active,
    cutoffOperator: turbine.MetricOperator.GreaterThan,
    cutoffValue: 0.9,
    trainingId: TRAINING_CREATING_ID
}
